import React, {useState, useEffect} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { 
  ResponsiveContainer,
  } from 'recharts';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import InfoIcon from '@mui/icons-material/Info';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
  IconButton,
  Grid,
  Tooltip,
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Badge,
  Avatar,
  CircularProgress
} from '@mui/material';
import { CSVLink } from "react-csv";

import Title from '../../../../components/Title';
import socket from '../../../../services/socket';

const useStylesTable = makeStyles({
  table: {
    minWidth: 400,
  },
});

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

function Item(props) {
    return (  
      <>
        <StyledBadge
          overlap="circle"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          variant="dot"
        >
          <Avatar alt="Remy Sharp" src={props.img_url} /> 
        </StyledBadge>
      </>
      );
}

export default function Team(props) {
  const store_id = props.store_id;
  const [TeamToday,setTeamToday] = useState([]);
  const classes = useStylesTable();
  const [isLoading,setIsLoading] = useState(true);
  const [csvDownloadInfo,setcsvDownloadInfo] = useState([])

  const csvHeaders = [
    { label: "Posição", key: "pos"},
    { label: "Nome", key: "name"},
    { label: "Vendas", key: "sales"}
  ];

  useEffect( () => {   
    function askTeamToday(){
      socket.emit('/vezo/StoreInfo/askTeamToday',{ 
                      'store_id': store_id,}
                    ,(data)=>{console.log(data);})
    }
    async function loadTeamToday(){
        askTeamToday()
        socket.on('/vezo/StoreInfo/updateTeamToday/'+store_id,()=>{
          // When the server sends a updatePaperInfo, it asks for newer intel
          askTeamToday();
        })
        socket.on('/vezo/StoreInfo/TeamToday/'+store_id,(data)=>{
          const initialSellers = data.map((row,index)=>{
            return ({    
                "id": row.id,
                "name":   row.name,
                "sales":   (row.sales).toFixed(2),
                'img_url': Buffer.from(row.image).toString(),
                "pos": index+1
            })   
          });
          const csvdata = data.map((row,index)=>{
            return ({ 
                "pos": index+1,   
                "name":   row.name,
                "sales":   (row.sales).toFixed(2),
            })   
          });
          setTeamToday(initialSellers);
          setcsvDownloadInfo(csvdata)
          setIsLoading(false);
        });
        return () => socket.disconnect();
    }
    loadTeamToday();    
    },[store_id]);

  return (
    <React.Fragment>
        <Grid container spacing={3}  justifyContent={"center"} direction="row">
            <Grid item xs={12} md={2} lg={1}>
                <Tooltip title="Equipe presente, nesta loja, hoje!">
                    <IconButton aria-label="Selecionar" size="large">
                        <InfoIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item xs={12} md={10} lg={10}>
                <Title><GroupAddIcon /> Equipe presente</Title>
            </Grid>
            <Grid item xs={12} md={2} lg={1}>
              <CSVLink filename={"vendedores_hoje.csv"} headers={csvHeaders} data={csvDownloadInfo}>
                <GetAppIcon />
              </CSVLink>
            </Grid>
        </Grid>
      <ResponsiveContainer>
      {isLoading ?
        <div style={{paddingTop:'10px'}}>
            <CircularProgress />
        </div>
      :
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="simple table">
                <TableHead>
                    <TableRow>
                    <TableCell> Posição</TableCell>
                    <TableCell> Vendedor</TableCell>
                    <TableCell align="right"> Nome </TableCell>
                    <TableCell align="right"> Vendas(R$) </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {TeamToday.map((row) => (
                    <TableRow key={row.name}>
                        <TableCell >{row.pos}</TableCell>
                        <TableCell component="th" scope="row">
                          <Item key={row.id} value={row.name} img_url={row.img_url} /> 
                        </TableCell>
                        <TableCell align="right"> {row.name} </TableCell>
                        <TableCell align="right"> {row.sales?row.sales:0} </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>}
      </ResponsiveContainer>
    </React.Fragment>
  );
}